var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4TeachingRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.08 46H69V11H40v35h3.92l-5.39 22h4.11L48 46h5v22h4V46h3.94l5.92 22H71l-5.92-22zM65 42H44V15h21v27zm-3-3H47v-3h15v3zm0-6H47v-3h15v3zm0-6H47v-3h15v3zm0-6H47v-3h15v3zM38 34.22a2.001 2.001 0 01-1.07 2.62l-6.17 2.6a2 2 0 01-.78.16 2 2 0 01-1.5-.6L24 34v32a2 2 0 01-2 2 1.79 1.79 0 01-1.85-2L20 50h-3v16a2 2 0 01-4 0V32h-1a1 1 0 00-1 1v12a2 2 0 01-4 0V33a1.618 1.618 0 010-.22A5 5 0 0112 28h10.85a1.999 1.999 0 011.47.64l6.13 6.58 4.89-2.06A1.998 1.998 0 0138 34.22zm-22.71-9.86a4 4 0 116.128-5.14 4 4 0 01-6.128 5.14z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Teaching_room.36af2ace.svg";
export { SvgE4TeachingRoom as ReactComponent };